<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Menu -->
        <menu-album
            :profil="profil"
        />

        <!-- Main -->
        <main>
            <div class="albumMainBody">

                <div class="albumPages">
                    <div class="albumPage --first"></div>
                    <div class="albumPage --second"></div>
                    <div class="albumPage --third"></div>
                    <div class="albumPage --fourth"></div>
                </div>    

                <button @click="$router.push({ name: 'profil' })" class="sideMenu__close"><span class="icon"></span></button>
                <div class="albumList__separator"></div>

                <!-- Recepty -->
                <div class="albumListing__wrap">

                    <!-- 1. strana -->
                    <div class="albumList__half --first">
                        <!-- Header -->
                        <div class="albumList__heading mb-3 d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">{{ recept_nadpis }}</h2>
                        </div>

                        <!-- Images -->
                        <div class="recept__images">
                            <div class="recept__mainImage mb-4">
                                <!-- *Preloader box -->
                                <img v-if="recept_img_a == ''" :src="'assets/img/album/recepty/ranajky-sendvic.jpg'" alt="" class="img-fluid --rounded" style="filter:brightness(0) invert(1) drop-shadow(0 0 2px #E0DBDA)">
                                <!-- *Content -->
                                <img v-else :src="'assets/img/album/recepty/' + recept_img_a" alt="" class="img-fluid --rounded">
                            </div>

                            <div class="recept__mainWrap">   
                                <div class="recept__ingredients">
                                    <span class="recept__label">Potrebujeme</span>
                                    <ul v-html="recept_priprava">
                                        {{ recept_priprava }}
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- 2. strana -->
                    <div class="albumList__half --second">
                        <!-- Text -->
                        <div class="recept__mainWrap">                            
                            <div class="recept__workaround">
                                <span class="recept__label">Postup</span>
                                <p>{{ recept_postup }}</p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="albumListing__nav --prev">
                    <router-link :to="{ name: 'album-recepty' }">
                        <span class="icon --prev"></span>Späť na zoznam receptov
                    </router-link>
                </div>

            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderObchod from '../partials/HeaderObchod.vue'
    import MenuAlbum    from '../partials/MenuAlbum.vue'
    export default {
        components: {
            HeaderObchod,
            MenuAlbum
        },
        props: [
            'profil',
            'album',
            'error'
        ],
        mounted() {
            this.toggleBodyClass('addClass', 'album')
            this.toggleBodyClass('addClass', '--receptyDetail')
            if (typeof(this.profil.id) == "undefined" || this.profil.id == 0) {
                this.$emit('updateProfil')
            }

            this.checkReceptInfo()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'album')
            this.toggleBodyClass('removeClass', '--recepty')
        },
        data() {
            return {
                recept_img_a: '',
                recept_img_b: '',
                recept_img_c: '',
                recept_nadpis: 'Názov receptu',
                recept_priprava: '',
                recept_postup: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },


            // mounted
            checkReceptInfo(typ) {
                EventService.getReceptInfo(this.$route.params.recept_id)
                    .then(response => {
                        //console.log(response.data)
                        this.recept_img_a = response.data.data.album_recepty_img_a
                        this.recept_img_b = response.data.data.album_recepty_img_b
                        this.recept_img_c = response.data.data.album_recepty_img_c
                        this.recept_nadpis = response.data.data.album_recepty_nadpis
                        this.recept_priprava = response.data.data.album_recepty_priprava
                        this.recept_postup = response.data.data.album_recepty_postup
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },
        }
    }
</script>